import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "WarningAlt"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.60961 21.3905C1.74604 21.6143 1.98944 21.7506 2.25156 21.7501H21.7516C22.0137 21.7506 22.2571 21.6143 22.3935 21.3905C22.53 21.1667 22.5396 20.8878 22.4191 20.6551L12.6691 1.9051C12.5407 1.65463 12.283 1.49707 12.0016 1.49707C11.7201 1.49707 11.4624 1.65463 11.3341 1.9051L1.58406 20.6551C1.46348 20.8878 1.47317 21.1667 1.60961 21.3905ZM12.0015 3.87759L20.514 20.2501H3.489L12.0015 3.87759ZM12 16.5001C11.3787 16.5001 10.875 17.0038 10.875 17.6251C10.875 18.2464 11.3787 18.7501 12 18.7501C12.6213 18.7501 13.125 18.2464 13.125 17.6251C13.125 17.0038 12.6213 16.5001 12 16.5001ZM12.75 8.25012H11.25V15.0001H12.75V8.25012Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/WarningAlt.vue"]]);
